module.exports = __webpack_public_path__ + "img/08.c851db5f.jpg";